import React, { useState } from "react";
import {updateCollapsedMenuId} from "../../../../_reducers/TabsSlice";
import {useDispatch, useSelector} from "react-redux";
import {setSettingExportTab, setSettingImportTab} from "../../../../_reducers/settingsSlice";
import {mobileSidebarToggle} from "../../../../_reducers/MobileSidebar";
import {checkPermission, getCurrentUser, isEmpty} from "../../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import {
    setClassificationsReportFrom,
} from "../../../../_reducers/DataPanel/Buys/buysSlice";
import {addTabIfNotExists, generateTabKey} from "../../../../_helpers/tabOpeners";
import {useTranslation} from "../../../../hooks/useTranslation";

const SideBarLink = ({title, linksInfo, id, requirement, permissionsData}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const COMPANY_DATA = useSelector((state) => state.COMPANY_DATA);
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const user = getCurrentUser();

    const [hoveredSubLinkId, setHoveredSubLinkId] = useState(null);

    const handleToggle = (id) => {
        if (linksInfo.length === 0) {
            if (TABS_DATA.some((el) => el.tabType === "working-program-employee")) {
                return toast.info("Παρακαλώ τελειώστε πρώτα με την επεξεργασία προγράμματος του εργαζομένου.");
            }
            const specialIds = ["working-program", "ergani-submissions-report", "payroll-qr-scanner", "payroll-hour-report", "visit-new", "prescription-home"]
            if (specialIds.includes(id)) {
                dispatch(addTabIfNotExists(id, generateTabKey(), TABS_DATA));
                dispatch(mobileSidebarToggle());
            }
        } else {
            dispatch(updateCollapsedMenuId(id));
        }
    }

    const handleLeftClick = (e, tabId) => {
        if (TABS_DATA?.includes("working-program-employee")) {
            return toast.info("Παρακαλώ τελειώστε πρώτα με την επεξεργασία προγράμματος του εργαζομένου.");
        }
        if (tabId === "classifications-report") {
            if (id === "my-data") {
                dispatch(setClassificationsReportFrom("sale"));
            } else if (id === "buys-mydata-report") {
                dispatch(setClassificationsReportFrom("buy"));
            }
        }
        dispatch(setSettingImportTab(0));
        dispatch(setSettingExportTab(0));
        dispatch(addTabIfNotExists(tabId, generateTabKey(), TABS_DATA));
        dispatch(mobileSidebarToggle());
    }

    const sideBarOptions = {
        hasBankingAI: aiSettings?.enableBankingAI || false,
        isAdmin: user?.userType === "Admin",
    }

    return (
        <React.Fragment>
            {(isEmpty(requirement) || (!isEmpty(requirement) && requirement(COMPANY_DATA))) && (
                <React.Fragment>
                    <li onClick={() => handleToggle(id)} style={{cursor: "pointer"}} className="nav-item border-bottom-1-gray">
                        <a className="nav-link" data-toggle="collapse" href={`#${id}`} aria-expanded={"false"} aria-controls={id}>
                            <span className="menu-title">{title}</span>
                            {linksInfo.length > 0 && <i className="menu-arrow"></i>}
                        </a>
                    </li>

                    {linksInfo.length > 0 && (
                        <div key={id} className="collapse" id={id}>
                            <ul className="nav flex-column sub-menu border-bottom-1-gray">
                                {linksInfo.map((info) => {
                                    const hasParentPermission = checkPermission(info.permission, permissionsData);
                                    const meetsParentRequirement = isEmpty(info?.requirement) || (!isEmpty(info?.requirement) && info.requirement(COMPANY_DATA, sideBarOptions));
                                    const hasSubLinks = info.subLinks && info.subLinks.length > 0;

                                    const validSubLinks = hasSubLinks
                                        ? info.subLinks.filter(subInfo => {
                                            const hasSubPerm = checkPermission(subInfo.permission, permissionsData);
                                            const meetsSubReq = isEmpty(subInfo?.requirement) || (!isEmpty(subInfo?.requirement) && subInfo.requirement(COMPANY_DATA, sideBarOptions));
                                            return hasSubPerm && meetsSubReq;
                                        })
                                        : [];

                                    const hasAnyValidSublink = validSubLinks.length > 0;
                                    if ((hasParentPermission && meetsParentRequirement) || hasAnyValidSublink) {

                                        if (hasSubLinks) {
                                            const isChildHovered = validSubLinks.some(sub => sub.id === hoveredSubLinkId);

                                            return (
                                                <li style={{cursor: "pointer"}} key={info.id} className={`nav-item ${isChildHovered ? 'disable-parent-hover' : ''}`}>
                                                    <a
                                                        className="nav-link"
                                                        data-toggle="collapse"
                                                        href={`#${info.id}`}
                                                        aria-expanded="false"
                                                        aria-controls={info.id}
                                                    >
                                                        <span className="menu-title">{t(info.name)}</span>
                                                        <i className="menu-arrow"></i>
                                                    </a>

                                                    <div className="collapse" id={info.id}>
                                                        <ul className="nav flex-column sub-menu" style={{ padding: 0 }}>
                                                            {validSubLinks.map((subInfo) => {
                                                                const isThisHovered = hoveredSubLinkId === subInfo.id;

                                                                return (
                                                                    <li
                                                                        style={{cursor: "pointer", width: "100%"}}
                                                                        key={subInfo.id}
                                                                        className="nav-item"
                                                                        onMouseEnter={() => setHoveredSubLinkId(subInfo.id)}
                                                                        onMouseLeave={() => setHoveredSubLinkId(null)}
                                                                    >
                                                                        <div
                                                                            id={subInfo.id}
                                                                            onClick={(e) => handleLeftClick(e, subInfo.id)}
                                                                            className={`nav-link ${isThisHovered ? 'active-teal-hover' : ''}`}
                                                                            style={{ paddingLeft: '2rem' }}
                                                                        >
                                                                            {t(subInfo.name)}
                                                                        </div>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                </li>
                                            );
                                        }

                                        return (
                                            <li style={{cursor: "pointer"}} key={info.id} className="nav-item">
                                                <div id={info.id} onClick={(e) => handleLeftClick(e, info.id)} className="nav-link">
                                                    {t(info.name)}
                                                </div>
                                            </li>
                                        );
                                    }

                                    return null;
                                })}
                            </ul>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default SideBarLink;